import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ShButtonComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-back-home',
    templateUrl: './back-home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule, ShButtonComponent]
})
export class BackHomeComponent {}
